import * as React from 'react';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

const Custom = styled(TextField)({
    '& .MuiInputLabel-root': {},
});

export default function CustomPublicField({
    errors,
    label,
    name,
    type,
    register,
    size,
    ...rest
}) {
    return (
        <Custom
            error={Boolean(errors)}
            helperText={errors?.message}
            fullWidth
            label={label}
            name={name}
            type={type}
            variant="outlined"
            {...register(name)}
            {...rest}
        />
    );
}
